require('./bootstrap');

import i18n from '@/Core/i18n';
import mixin from '@/Core/mixin';
import Icons from '@/Shared/Icons';

import vSelect from 'vue-select';
import { createApp, h } from 'vue';
import { InertiaProgress } from '@inertiajs/progress';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Jet Start';

createInertiaApp({
  title: title => `${title} - ${appName}`,
  resolve: name => require(`./Pages/${name}.vue`).default,
  setup({ el, app, props, plugin }) {
    return createApp({ render: () => h(app, props) })
      .use(i18n)
      .use(plugin)
      .component('Icons', Icons)
      .component('v-select', vSelect)
      .mixin({ methods: { route } })
      .mixin(mixin)
      .mount(el);
  },
});

InertiaProgress.init({ color: '#2563eb' });
